
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[postSlug]",
      function () {
        return require("private-next-pages/[postSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[postSlug]"])
      });
    }
  